<template>
  <div v-if="reportLoaded">
    <v-row v-for="(customerReport, index) of report.results" :key="index">
      <v-col v-if="customerReport.comparisonResult" md="6" cols="12">
        <route-data-quality-report-card
          :customer-report="customerReport.standardResult"
          :start-date="startDate"
          :end-date="endDate"
          :timezone="timezone"/>
      </v-col>
      <v-col v-if="customerReport.comparisonResult" md="6" cols="12">
        <route-data-quality-report-card
          :customer-report="customerReport.comparisonResult"
          :comparison="true"
          :start-date="comparisonStartDate"
          :end-date="comparisonEndDate"
          :timezone="timezone"/>
      </v-col>
      <v-col v-else md="12" cols="12">
        <route-data-quality-report-card
          :customer-report="customerReport.standardResult"
          :start-date="startDate"
          :end-date="endDate"
          :timezone="timezone"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RouteDataQualityReportCard from '@/components/report/RouteDataQualityReportCard'
import ReportRecord from '@/orm/models/ReportRecord'
import Moment from 'moment-timezone'
import { get } from 'lodash'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTruck, faInfoCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faTruck, faInfoCircle)

export default {
  name: 'RouteDataQualityReport.vue',
  components: {
    RouteDataQualityReportCard
  },
  props: {
    report: {
      type: ReportRecord
    }
  },
  data () {
    return {}
  },
  computed: {
    /**
     * Identifies if the report is loaded
     * @return boolean
     */
    reportLoaded () {
      return this.report && this.report.results_generated != null
    },
    /**
     * @return array
     */
    reportResults () {
      return Object.values(get(this, 'report.results') || {})
    },
    startDate () {
      return get(this, 'report.parameters.startDate')
    },
    endDate () {
      return get(this, 'report.parameters.endDate')
    },
    comparisonStartDate () {
      return get(this, 'report.parameters.comparisonStartDate')
    },
    comparisonEndDate () {
      return get(this, 'report.parameters.comparisonEndDate')
    },
    /**
     * Get the timezone that the report is operating under.
     */
    timezone () {
      return get(this.report, 'parameters.timezone')
    }
  }
}
</script>

<style scoped>
</style>
